module.exports = __webpack_public_path__ + "static/bgDeveloper.530fdfcc.png";